(ns sentry.integration
  (:require
   ["@sentry/react" :as Sentry]
   [clojure.string :as string]
   [oops.core :as oops]))

(defonce reported-missing-localizations* (atom #{}))

(defn init-sentry []
  ;; DO NOT POST from developer machine
  (when-not (string/starts-with? (str js/location.href)
                                 "http://")
    (oops/ocall Sentry "init"
                #js {:dsn                      "https://2405964589105d158f71783793ea0aaf@o4508330576117760.ingest.de.sentry.io/4508330578608208"
                     :integrations             (clj->js [(oops/ocall Sentry "browserTracingIntegration")
                                                         (oops/ocall Sentry "replayIntegration")])
                     :tracesSampleRate         1.0
                     :tracePropagationTargets  (clj->js ["localhost" "zapflow"])
                     :replaysSessionSampleRate 0.1
                     :replaysOnErrorSampleRate 1.0})))

(defn report-missing-localization!
  [k lang]
  (let [cache-key [k lang]]
    (when-not (contains? @reported-missing-localizations* cache-key)
      (swap! reported-missing-localizations* conj cache-key)
      (oops/ocall Sentry "withScope"
                  (fn [scope]
                    (oops/ocall scope "setLevel" "warning")
                    (oops/ocall scope "setTag" "area" "localization")
                    (oops/ocall scope "setTag" "language" (name lang))
                    (oops/ocall scope "setContext"
                                "missing_localization"
                                #js {:key (name k)
                                     :keyword (str k)
                                     :lang (name lang)})
                    (oops/ocall Sentry "captureMessage"
                                (str "Missing localization key: " k " (" (name lang) ")")))))))
